module.exports = __webpack_public_path__ + "static/img/2.0445fe3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/4/zh/2.png
// module id = 5oEu
// module chunks = 0